import React__default, { useMemo } from 'react';
import { useStyles } from '@sravni/react-utils';
import { makeRelAttribute } from '../../../utils/links.js';
import modules_973b0c03 from '../styles/HiddenLinks.module.less.js';

const HiddenLinks = (props) => {
    const { menu, hideTopLinks, className, ...rest } = props;
    const cx = useStyles(modules_973b0c03);
    const menuFlat = useMemo(() => {
        const toFlat = (acc, item, params) => {
            const { hideCurrentLevel } = params || {};
            if (!hideCurrentLevel && item.isLink && item.href) {
                // eslint-disable-next-line @typescript-eslint/no-unused-vars
                const { children, ...rest } = item;
                acc.push(rest);
            }
            if (item.children && item.children.length > 0) {
                item.children.forEach((innerItem) => toFlat(acc, innerItem));
            }
            return acc;
        };
        return menu.reduce((acc, item) => toFlat(acc, item, { hideCurrentLevel: hideTopLinks }), []);
    }, [hideTopLinks, menu]);
    return (React__default.createElement("div", { className: cx('hiddenLinks', className), ...rest }, menuFlat.map((item, i) => {
        const { text, href } = item;
        if (!text || !href)
            return null;
        return (React__default.createElement("a", { 
            // Больше ничего уникального нет. text и href повторяются у 5 ссылок на отзывы банков
            // eslint-disable-next-line react/no-array-index-key
            key: i, href: href, rel: makeRelAttribute(item) }, text));
    })));
};

export { HiddenLinks };
//# sourceMappingURL=HiddenLinks.js.map
